import { Col, Row } from "antd";
import React, { useEffect } from "react";
import ProgressCard from "./progressCard";
import ProfileCard from "./profileCard";
import HistoryComponent from "./history";
import { useSelector } from "react-redux";
import { constants } from "../../../constants/common";
import { useMutation } from "@apollo/client";
import { GET_ATTENDANCE_SUMMARY } from "../../../actions/graphql/mutations/attendance/attendance";
import moment from 'moment';
import Timesheet from "../../home/Welcome/Timesheet";

type AttendanceSummary = {
    overtime: number;
    thisMonth: number;
    thisWeek: number;
    thisYear: number;
    today: number;
};

type GetAttendanceSummaryResponse = {
    getAttendanceSummary: AttendanceSummary;
};

const Attendance = () => {
    const { user } = useSelector((state: any) => state.app);

    const [getAttendanceSummary, { data, loading, error }] = useMutation<GetAttendanceSummaryResponse>(GET_ATTENDANCE_SUMMARY);

    useEffect(() => {
        handleFetch();
    }, [])

    const handleFetch = () => {
        getAttendanceSummary({
            variables: { month: moment().format('MM-YYYY') }, // example value
        });
    };

    const attendance = [
        { name: 'Today', progress: data?.getAttendanceSummary?.today },
        { name: 'This Week', progress: data?.getAttendanceSummary?.thisWeek },
        { name: 'This Month', progress: data?.getAttendanceSummary?.thisMonth },
        { name: 'This Year', progress: data?.getAttendanceSummary?.thisYear },
        { name: 'Overtime', progress: data?.getAttendanceSummary?.overtime },
        { name: 'Overtime', progress: data?.getAttendanceSummary?.overtime },
    ]

    const onViewProfile = () => { }

    return <Row gutter={[8, 8]}>
        {attendance.map(ele => <Col span={4}>
            <ProgressCard
                progress={ele.progress}
                title={ele.name}
            />
        </Col>)}
        <Col span={12}>
            <ProfileCard
                email={user?.email}
                employeeId={user?.employeeId}
                location="Nagpur"
                name={user ? constants.GET_FULL_NAME(user) : ''}
                onTimePercentage="90"
                onViewProfile={onViewProfile}
                phone={user?.mobile}
                role={user?.role?.name}
                avatar={user?.avatar}
            />
        </Col>
        <Col span={12}>
            <Timesheet />
        </Col>
        <Col span={24}>
            <HistoryComponent />
        </Col>
    </Row>
}

export default Attendance;